import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LogisticsChargesService {

    constructor(private _http: HttpClient) { }

    getcharges(data) {
        return this._http.post(environment.api_url+'admin/logistic/pricing',data);
    }

}
